import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as nls from '../../../nls.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { registerEditorContribution } from '../../browser/editorExtensions.js';
import { ICodeEditorService } from '../../browser/services/codeEditorService.js';
import { IDialogService } from '../../../platform/dialogs/common/dialogs.js';
var ignoreUnusualLineTerminators = 'ignoreUnusualLineTerminators';

function writeIgnoreState(codeEditorService, model, state) {
  codeEditorService.setModelProperty(model.uri, ignoreUnusualLineTerminators, state);
}

function readIgnoreState(codeEditorService, model) {
  return codeEditorService.getModelProperty(model.uri, ignoreUnusualLineTerminators);
}

var UnusualLineTerminatorsDetector = /*#__PURE__*/function (_Disposable) {
  _inherits(UnusualLineTerminatorsDetector, _Disposable);

  var _super = _createSuper(UnusualLineTerminatorsDetector);

  function UnusualLineTerminatorsDetector(_editor, _dialogService, _codeEditorService) {
    var _this;

    _classCallCheck(this, UnusualLineTerminatorsDetector);

    _this = _super.call(this);
    _this._editor = _editor;
    _this._dialogService = _dialogService;
    _this._codeEditorService = _codeEditorService;
    _this._config = _this._editor.getOption(103
    /* unusualLineTerminators */
    );

    _this._register(_this._editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(103
      /* unusualLineTerminators */
      )) {
        _this._config = _this._editor.getOption(103
        /* unusualLineTerminators */
        );

        _this._checkForUnusualLineTerminators();
      }
    }));

    _this._register(_this._editor.onDidChangeModel(function () {
      _this._checkForUnusualLineTerminators();
    }));

    _this._register(_this._editor.onDidChangeModelContent(function (e) {
      if (e.isUndoing) {
        // skip checking in case of undoing
        return;
      }

      _this._checkForUnusualLineTerminators();
    }));

    return _this;
  }

  _createClass(UnusualLineTerminatorsDetector, [{
    key: "_checkForUnusualLineTerminators",
    value: function _checkForUnusualLineTerminators() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var model, ignoreState, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._config === 'off')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (this._editor.hasModel()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                model = this._editor.getModel();

                if (model.mightContainUnusualLineTerminators()) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                ignoreState = readIgnoreState(this._codeEditorService, model);

                if (!(ignoreState === true)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                if (!this._editor.getOption(72
                /* readOnly */
                )) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return");

              case 12:
                if (!(this._config === 'auto')) {
                  _context.next = 15;
                  break;
                }

                // just do it!
                model.removeUnusualLineTerminators(this._editor.getSelections());
                return _context.abrupt("return");

              case 15:
                _context.next = 17;
                return this._dialogService.confirm({
                  title: nls.localize('unusualLineTerminators.title', "Unusual Line Terminators"),
                  message: nls.localize('unusualLineTerminators.message', "Detected unusual line terminators"),
                  detail: nls.localize('unusualLineTerminators.detail', "This file contains one or more unusual line terminator characters, like Line Separator (LS) or Paragraph Separator (PS).\n\nIt is recommended to remove them from the file. This can be configured via `editor.unusualLineTerminators`."),
                  primaryButton: nls.localize('unusualLineTerminators.fix', "Fix this file"),
                  secondaryButton: nls.localize('unusualLineTerminators.ignore', "Ignore problem for this file")
                });

              case 17:
                result = _context.sent;

                if (result.confirmed) {
                  _context.next = 21;
                  break;
                }

                // this model should be ignored
                writeIgnoreState(this._codeEditorService, model, true);
                return _context.abrupt("return");

              case 21:
                model.removeUnusualLineTerminators(this._editor.getSelections());

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return UnusualLineTerminatorsDetector;
}(Disposable);

UnusualLineTerminatorsDetector.ID = 'editor.contrib.unusualLineTerminatorsDetector';
UnusualLineTerminatorsDetector = __decorate([__param(1, IDialogService), __param(2, ICodeEditorService)], UnusualLineTerminatorsDetector);
registerEditorContribution(UnusualLineTerminatorsDetector.ID, UnusualLineTerminatorsDetector);